import { useState, useEffect } from "react";
import { client } from "../sanity/client";

function Education() {
  const [education, setEducation] = useState(null);
  useEffect(() => {
    client.fetch('*[_type == "education"][0]').then((data) => {
      setEducation(data);
    });
  }, []);
  return (
    <>
      <div className="section">
        <p>
          <span className="prompt">ziad@portfolio:</span>
          <span className="path">~</span>
          <span className="command">$ cd education</span>
        </p>
        <p>
          👨🏻‍🎓
          <strong> {education?.institution} </strong>
          <br />
          <span className="work-date">{education?.location}</span> <br />—{" "}
          {education?.degree}
          <br />
        </p>
      </div>
    </>
  );
}
export default Education;
